import styled from 'styled-components';

const ReportMustHaveFilterValueText = styled.span`
  > div {
    margin-bottom: ${(props): string => props.theme.spaces.md};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export { ReportMustHaveFilterValueText };
